// src/components/NodeManagement/components/ErrorMessage.jsx
import React from 'react';

const ErrorMessage = ({ message }) => (
  <div className="error-message">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2"/>
      <path d="M12 8V12" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 16H12.01" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
    </svg>
    <span>{message}</span>
  </div>
);

export default ErrorMessage;
